// @flow
import type {Element} from 'react'
import React from 'react'

import Value from 'components/proposals/Part/ui/Value'
import Scalar from 'components/proposals/Part/ui/Summary/Scalar'
import styles from '../index.scss'

type Props = $ReadOnly<{
  section: any,
}>

function Attribute({section}: Props): Element<"div"> {
  const isDeleted = section.new_value === null
  const value = new Value(section.old_value, section.new_value, {isDeleted, htmlDiff: section.html_diff})

  return (
    <div className={styles.attribute}>
      <Scalar
        title={section.title}
        value={value}
        changeKey={`${section.type}_${section.title}`}
      />
    </div>
  )
}

export default Attribute
